import type {RouterOutput} from '@common-web/lib/trpc';
import {MEMBER_FIELD_LABELS, REQUIRED_MEMBER_LABELS} from '../member-fields';

export const TEMPLATE_COLUMNS = MEMBER_FIELD_LABELS;

export const STANDARD_MAPPING_FIELDS = [...MEMBER_FIELD_LABELS].sort();

export const HEADER_ALIASES: Record<string, string> = {
  'address line 1': 'Address 1',
  'address line 2': 'Address 2',
  address1: 'Address 1',
  address2: 'Address 2',
  apt: 'Address 2',
  'birth date': 'Date of Birth',
  birthdate: 'Date of Birth',
  birthday: 'Date of Birth',
  'date hired': 'Hire Date',
  'date of birth': 'Date of Birth',
  dob: 'Date of Birth',
  'email address': 'Email',
  'emp id': 'Employee ID',
  'employee #': 'Employee ID',
  'employee number': 'Employee ID',
  empid: 'Employee ID',
  first: 'First Name',
  firstname: 'First Name',
  fname: 'First Name',
  hiredate: 'Hire Date',
  last: 'Last Name',
  lastname: 'Last Name',
  lname: 'Last Name',
  mi: 'Middle Name',
  middle: 'Middle Name',
  'middle initial': 'Middle Name',
  'middle name': 'Middle Name',
  middlename: 'Middle Name',
  'phone number': 'Phone',
  postal: 'Zip',
  'postal code': 'Zip',
  sex: 'Gender',
  'sex code': 'Gender',
  'social security': 'SSN',
  'social security #': 'SSN',
  'social security number': 'SSN',
  'ss #': 'SSN',
  'ss#': 'SSN',
  'ssn #': 'SSN',
  'ssn#': 'SSN',
  st: 'State',
  'start date': 'Hire Date',
  street: 'Address 1',
  'street address': 'Address 1',
  suite: 'Address 2',
  telephone: 'Phone',
  unit: 'Address 2',
  'zip code': 'Zip',
  zipcode: 'Zip',
};

export const REQUIRED_MAPPINGS = REQUIRED_MEMBER_LABELS;

// Product assignment happens through the analyzer flow after import, so the
// default flow only collects the coverage date. Champ is the exception: its
// groups still assign products at import time. Both flows have the same step
// count/indices — only the coverage step's label and contents differ.
export const STEPS = [
  'Upload',
  'Validation',
  'Duplicate Check',
  'Mapping',
  'Coverage',
  'Processing',
  'Results',
] as const;

export const CHAMP_STEPS = [
  'Upload',
  'Validation',
  'Duplicate Check',
  'Mapping',
  'Coverage & Products',
  'Processing',
  'Results',
] as const;

export type ColumnMapping = {
  csvHeader: string;
  systemField: string;
};

export type ImportResponse = RouterOutput['group']['vbaMembers']['importEligibility'];

export type ImportedMember = {id: string; name: string};

export type ImportResult = {
  created: number;
  createdMembers: ImportedMember[];
  totalRows: number;
  errors: Array<{row: number; message: string; data?: Record<string, string>}>;
  warnings: Array<{row: number; message: string}>;
};

export type ValidationIssue = {row: number; message: string; severity: 'error' | 'warning'};

export type ParseState = {
  csvHeaders: string[];
  csvRows: string[][];
  duplicates: {indices: number[]; key: string}[];
  mappings: ColumnMapping[];
  rawRowCount: number;
  totalRows: number;
  validationErrors: ValidationIssue[];
  validationWarnings: ValidationIssue[];
};

export const INITIAL_PARSE_STATE: ParseState = {
  csvHeaders: [],
  csvRows: [],
  duplicates: [],
  mappings: [],
  rawRowCount: 0,
  totalRows: 0,
  validationErrors: [],
  validationWarnings: [],
};
